import { useQuery } from '@apollo/client';
import {
  useGetGuidParam,
  useGetOptionalGuidParam,
} from '@risksmart-app/components/src/routes/routes.utils';
import { ParentTypes } from '@risksmart-app/domain/src/types/consts';
import {
  GetComplianceMonitoringAssessmentByIdDocument,
  GetSecondLineResultByIdDocument,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ControlledTabs from 'src/components/controlled-tabs';
import { PageLayout } from 'src/layouts';

import { useTabs } from '../useTabs';

const Page: FC = () => {
  const { t } = useTranslation(['common'], { keyPrefix: 'assessmentResults' });
  const title = t('edit_title');
  const optionalAssessmentId = useGetOptionalGuidParam('assessmentId');
  const findingId = useGetGuidParam('findingId');
  const { data: resultData, error: resultError } = useQuery(
    GetSecondLineResultByIdDocument,
    {
      variables: { Id: findingId },
      skip: !!optionalAssessmentId,
    }
  );
  if (resultError) {
    throw resultError;
  }
  const resultParentId = resultData?.second_line_result_parent.find(
    (ar) => ar.ParentType === ParentTypes.ComplianceMonitoringAssessment
  )?.ParentId;
  const assessmentId = optionalAssessmentId ?? resultParentId;

  const { data, error } = useQuery(
    GetComplianceMonitoringAssessmentByIdDocument,
    {
      variables: {
        Id: assessmentId!,
      },
      skip: !assessmentId,
    }
  );
  if (error) {
    throw error;
  }

  const assessment = data?.compliance_monitoring_assessment?.[0];

  const tabs = useTabs(
    assessment || undefined,
    'update',
    !optionalAssessmentId,
    !!optionalAssessmentId
  );

  return (
    <PageLayout title={title}>
      <ControlledTabs tabs={tabs} variant={'container'} parent={assessment} />
    </PageLayout>
  );
};

export default Page;
